import React, { useEffect } from 'react';
import { Row } from '@thd-olt-component-react/core-ui';
import { Price } from '@thd-olt-component-react/price';
import { Typography } from '@one-thd/sui-atomic-components';
import {
  string,
  useDataModel,
  extend
} from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../../../../../utils/empty-reference';
import { useCabinetVisualizerStore } from '../../../../../store';
import logNewRelicCustom from '../../../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../../../constants';

export const ProductInfo = ({ setProductDataLoading }) => {

  const {
    styleChoiceId,
    skuDrawer: {
      selectedItemId: itemId
    }
  } = useCabinetVisualizerStore((state) => state.cabinetVisualizer);

  const { storeId = '121' } = useStore();

  const { data: productData,
    loading: productDataLoading } = useDataModel('product', {
    variables: { itemId, storeId },
    ssr: true,
    skip: !itemId
  });

  const product = productData?.product || EMPTY_OBJECT;

  if (product !== EMPTY_OBJECT && !product?.pricing) {
    logNewRelicCustom(NEW_RELIC_EVENTS.PRICE_PRODUCT_LOOKUP_FAIL, { itemId, storeId, styleChoiceId });

  }

  const getMedia = () => {
    const imageUrl = product?.media?.images?.find((image) => image.subType?.toLowerCase() === 'primary');
    return imageUrl?.url.replace(/<SIZE>/, '400');
  };

  useEffect(() => {
    setProductDataLoading(productDataLoading);
  }, [productDataLoading, setProductDataLoading]);

  return itemId ? (
    <>
      <Row className="productDrawerImage sui-justify-center">
        {product?.media && (
          <img
            src={getMedia()}
            width="auto"
            height="auto"
            alt={product?.identifiers?.productLabel}
          />
        )}
      </Row>
      <Row>
        <div className="sui-flex custom-price">
          <ErrorBoundary name="eb-price-mobile-expanded">
            <Price
              itemId={itemId}
              type="simple"
              displayEachUom={false}
              disableOuterSpacing={false}
              clsRemediation={{
                placeholders: true,
                preservePlaceholders: true
              }}
            />
          </ErrorBoundary>
        </div>
      </Row>
      <Row>
        <Typography variant="body-base" color="primary">
          {product?.identifiers?.productLabel}
        </Typography>
      </Row>
    </>
  ) : (
    <>
      {/* Maybe put a skeleton here IDK */}
    </>
  );
};

ProductInfo.propTypes = {
  setProductDataLoading: PropTypes.func.isRequired,
};

ProductInfo.dataModel = extend(
  Price
);